// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"17":"infoboxcomparison","278":"infobox","522":"Debugger","663":"credits","668":"textbanner","923":"infoboxvideo"}[chunkId] || chunkId) + "." + {"17":"6be4104b","22":"3b1583a4","278":"3e9599b7","522":"941abe5b","652":"197e6c87","663":"525fef7a","668":"d38273e5","923":"c9c39bfc"}[chunkId] + ".js";
};